<template>
    <div class="el-page-header lesson-data-pageHeader">
        <div class="el-page-header__left" @click="goBack">
            <i class="el-icon-back"></i>
            <div class="el-page-header__title">返回</div>
        </div>
        <slot name="body"></slot>
        <slot name="action"></slot>
    </div>
</template>

<script>
export default {
    methods: {
        goBack () {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss">
.lesson-data-pageHeader {
    height: 100%;
    padding: 0 20px;
    align-items: center;
    > * {
        flex: 1;
    }
    .el-page-header__left {
        margin-right: 0;
        &::after {
            position: relative;
            top: 12px;
        }
        & + div {
            margin-left: 20px;
        }
    }
    .el-page-header__content {
        flex: 1;
        padding-right: calc(52px + 40px);
        color: inherit;
    }
}
</style>

